import Footer from 'components/layout/footer';
import Logo from 'components/layout/logo';
import MainContainer from 'components/layout/main_container';
import SwitchComponent from 'components/internationalization_switch';
import { Link } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import { Container, Button, Toolbar, Box, ButtonGroup } from 'components/ui';
import { DashboardLink } from 'utils/link';
import { MainDiv, BackgroundGraientContainer } from 'components/styles_components/container';
import { TopMenuTitleTypography } from 'components/styles_components/typography';
import { FormattedMessage } from 'react-intl';
import { LoginLink } from 'utils/link';
import { ButtonLink } from 'components/styles_components/link';

const CommonRoute = () => {
  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 2 }}>
        <Toolbar sx={{ pb: 2 }}>
          <ButtonLink to={DashboardLink()}>
            <Logo width="50">
              <TopMenuTitleTypography>
                <FormattedMessage id="app_name" />
              </TopMenuTitleTypography>
            </Logo>
          </ButtonLink>
          <Box sx={{ flexGrow: 1 }} />
          <SwitchComponent />
          <ButtonGroup>
            <Button
              component={Link}
              variant="contained"
              color="primary"
              to={LoginLink()}>
              <FormattedMessage id="button.login" />
            </Button>
          </ButtonGroup>
        </Toolbar>
      </Container>
      <BackgroundGraientContainer>
        <MainDiv>
          <MainContainer>
            <Outlet />
          </MainContainer>
        </MainDiv>
        <Footer />
      </BackgroundGraientContainer>
    </>
  );
};

export default CommonRoute;
